import { AwardKeys } from '../redux';

export type AwardType = {
  id: AwardKeys;
  name: string;
  description: string;
};

export const externalPointAward: AwardType = {
  id: 'externalPointAward',
  name: 'External Point Award',
  description:
    'Award members an amount of points designated by an external system each time they fulfill the offer',
};

export const nullAward: AwardType = {
  id: 'nullAward',
  name: 'Null Award',
  description: 'This type of offer does not provide the membership with an award within Activate',
};

export const pointAward: AwardType = {
  id: 'pointAward',
  name: 'Points Award',
  description: 'Award a member an amount of points each time they fulfill the offer',
};

export const pointsPerAward: AwardType = {
  id: 'pointsPerAward',
  name: 'Points Per Award',
  description: 'Award a member an amount of points by a multiplier on qualifying items',
};

export const awardTypes = {
  externalPointAward,
  nullAward,
  pointAward,
  pointsPerAward,
};
